<template>
  <div v-if="!isOnline || !countdown" :class="['auto-shutdown-details__row', 'auto-shutdown-details__row--gap-small']">
    <span v-if="startingDate" class="auto-shutdown-details__label"> {{ t("Date.start") }} {{ startingDate }} </span>
    <span v-if="endDate" class="auto-shutdown-details__label">{{ t("Date.end") }} {{ endDate }} </span>
  </div>

  <div v-else :class="['auto-shutdown-details__row', 'auto-shutdown-details__row--gap-small']">
    <span class="auto-shutdown-details__label">{{ t("Uptime.shuttingDownIn") }} {{ countdown }} </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import { useStore } from "@/composable/useStore"
import Utils from "@/utils/utils"

export default defineComponent({
  name: "ScheduleLabel",
  props: {
    isOnline: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const { spaceModule } = useStore()
    const t = createTranslationModule("WorkspaceEdit.Header.AutoShutdownDetails")

    const schedule = computed(() => {
      return spaceModule.scheduleModule.scheduledOnOff
    })

    const startingDate = computed(() => {
      if (schedule.value.autoStartupAt) {
        return Utils.dateFormatWithTime(schedule.value.autoStartupAt)
      }
      return null
    })

    const endDate = computed(() => {
      if (props.isOnline) {
        const { autoShutdownDefinition } = spaceModule.watching

        if (autoShutdownDefinition) {
          return Utils.dateFormatWithTime(autoShutdownDefinition?.scheduledToShutdownAt)
        }
      } else if (schedule.value.autoShutdownAt) {
        return Utils.dateFormatWithTime(schedule.value.autoShutdownAt)
      }

      return null
    })

    const countdown = computed(() => {
      if (spaceModule.watching && spaceModule.watching.autoShutdownDefinition) {
        const { days, hours, min } = Utils.dateRange(
          Date.now(),
          spaceModule.watching.autoShutdownDefinition.scheduledToShutdownAt
        )

        if (days > 0) {
          return null
        } else {
          if (hours) {
            return `${hours}${t("Uptime.h")} ${min}${t("Uptime.min")}`
          } else {
            return `${min}${t("Uptime.min")}`
          }
        }
      }

      return null
    })

    return {
      t,
      countdown,
      startingDate,
      endDate
    }
  }
})
</script>
